import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Instagram, Youtube, Lock } from "lucide-react";
import { useSite } from "@/context/SiteContext";

export default function Footer() {
  const { site } = useSite();
  const year = new Date().getFullYear();

  return (
    <footer className="bg-slate-950 text-slate-300" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img src="/ptg-mark.png" alt="Prasad Tutor Group logo" className="h-11 w-11 rounded-xl object-cover" data-testid="footer-logo-mark" />
              <div>
                <div className="font-heading text-lg font-extrabold text-white">PTG</div>
                <div className="text-[11px] font-semibold text-sky-400 uppercase tracking-widest">Prasad Tutor Group</div>
              </div>
            </div>
            <p className="text-sm text-slate-400 leading-relaxed">
              Quality Education. Personal Attention. Proven Results. Trusted by families since 2003.
            </p>
            <div className="flex gap-3 mt-5">
              {site.instagram_url ? (
                <a href={site.instagram_url} target="_blank" rel="noreferrer" className="flex h-10 w-10 items-center justify-center rounded-lg bg-slate-800 hover:bg-pink-600 transition-colors" data-testid="footer-instagram">
                  <Instagram className="h-5 w-5" />
                </a>
              ) : null}
              {site.youtube_url ? (
                <a href={site.youtube_url} target="_blank" rel="noreferrer" className="flex h-10 w-10 items-center justify-center rounded-lg bg-slate-800 hover:bg-red-600 transition-colors" data-testid="footer-youtube">
                  <Youtube className="h-5 w-5" />
                </a>
              ) : null}
            </div>
          </div>

          <div>
            <h4 className="text-white font-bold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              {[["Home", "/"], ["About Us", "/about"], ["Courses", "/courses"], ["Results", "/results"]].map(([l, p]) => (
                <li key={p}><Link to={p} className="hover:text-sky-400 transition-colors">{l}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold mb-4">More</h4>
            <ul className="space-y-2 text-sm">
              {[["Gallery", "/gallery"], ["Videos", "/videos"], ["Contact", "/contact"], ["Privacy Policy", "/privacy"], ["Terms & Disclaimer", "/terms"]].map(([l, p]) => (
                <li key={p}><Link to={p} className="hover:text-sky-400 transition-colors">{l}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold mb-4">Contact</h4>
            <ul className="space-y-3 text-sm text-slate-400">
              <li className="flex gap-2"><MapPin className="h-4 w-4 mt-0.5 text-sky-400 shrink-0" /> {site.address}</li>
              <li className="flex gap-2"><Phone className="h-4 w-4 mt-0.5 text-sky-400 shrink-0" /> {site.phone}</li>
              <li className="flex gap-2"><Mail className="h-4 w-4 mt-0.5 text-sky-400 shrink-0" /> {site.email}</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-12 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <p>© {year} Prasad Tutor Group (PTG). All rights reserved.</p>
          <Link to="/admin/login" className="inline-flex items-center gap-1.5 rounded-full border border-slate-700 px-3 py-1.5 font-semibold text-slate-300 hover:text-white hover:border-slate-500 hover:bg-slate-800 transition-colors" data-testid="footer-admin-link"><Lock className="h-3.5 w-3.5" /> Admin Login</Link>
        </div>
      </div>
    </footer>
  );
}
